import EditorTable from './EditorTable'

export default EditorTable
